export class EventModel {
    id:number
    loa_number:string
    event_type_name:string
    city_name:string
    budget_currency_type_details:string
    bec_event_planner_name:string
    assigned_to_name:string
    assigned_group_name:string
    event_manager_name:string
    photo_url:string
    country:string
    state:string
    created_at:string
    modified_at:string
    event_name:string
    event_url:string
    event_type:number
    number_of_attendees:number
    photo:string
    start_datetime:string
    end_datetime:string
    budget_type:string
    budget_amount:number
    created_by:number
    modified_by:number
    city:number
    budget_currency_type:number
    bec_event_planner:number
    assigned_to:number
    assigned_group:number
    event_manager:number
    client:StandardModel
    status:string
    status_name:string
    project_details:StandardModel
    time_zone_details:any
    sourcing_need: number
}



export class EventResponseModel {
    count:number
    next:string
    previous:string
    results: EventModel[]
}

export class Quotation {
        id:number
        created_by_name:string
        created_by:number
        modified_by_name:string
        modified_by:number
        created_at:string
        modified_at:string
        event_name:string
        event_url:string
        outsourcing_form_details:string
        outsourcing_event_request_details:string
        request_title:string
        issued_date:string
        due_date:string
        status:string
        general_instructions_for_vendors:string
        outsourcing_form:string
        outsourcing_event_request:number
}

// export class Vendor {
//     id:number
//     created_by_name:string
//     created_by:number
//     modified_by_name:string
//     modified_by:number
//     created_at:string
//     modified_at:string
//     name:string
//     email:string
//     contact_person:string
//     phone_number:string
//     notes:string
//     categories_serviced:string
//     description:string
//     location:string
//     created_by_id:number
//     modified_by_id:number
//     city:number
//     event:number
//     city_details
// }

// export class VendorResponseModel{
//     count:number
//     next:string
//     previous:string
//     results: Vendor[]

// }
export class QuotationResponseModel {
    count:number
    next:string
    previous:string
    results: Quotation[]
}

export class Invoice {
    id :number
    created_by_name :string
    created_by :number
    modified_by_name :string
    modified_by :number
    created_at :string
    modified_at :string
    invoice_number :string
    issue_date :string
    due_date :string
    total_amount :number
    status :string
    description :string
    created_by_id :number
    modified_by_id :number
    vendor :number
    quotation_request :number
    event :number
    currency_type :number
    vendor_details:string
    event_details:string
    quotation_request_details:string
    currency_type_details:string
    file:any
    file_details:any
}

export class InvoiceResponseModel {
    count:number
    next:string
    previous:string
    results: Invoice[]
}


export class Payment {
    id:number
    created_by_name:string
    created_by:number
    modified_by_name:string
    modified_by:number
    created_at:string
    modified_at:string
    invoice_details:string
    payment_date:string
    amount_paid:string
    payment_method:string
    transaction_id:string
    notes:string
    invoice:number
    recorded_by:number
    file:any
    file_details:any
    status:string
}

export class AdvancePayment {
    id:number
    created_by_name:string
    created_by:number
    modified_by_name:string
    modified_by:number
    created_at:string
    modified_at:string
    payment_date:string
    amount_paid_usd:string
    amount_paid:string
    amount_paid_selected_currency:string
    usd_currency_exchange_rate:string
    payment_method:string
    submission:string
    transaction_id:string
    paid_currency:number
    notes:string
    time_zone:number
    file:any
    file_details:any
    status:string
    recorded_by:string
    vendor_details:StandardModel
}

export class AdvancePaymentResponseModel {
    count:number
    next:string
    previous:string
    results: AdvancePayment[]
}

export class PaymentResponseModel {
    count:number
    next:string
    previous:string
    results: Payment[]
}

export class VendorTaxesModel{
        id:number
        country_name:string
        name:string
        rate:string
        country:number
}

export class VendortaxResponseModel {
    count:number
    next:string
    previous:string
    results: VendorTaxesModel[]
}


export class City {
    id:number
    name:string
    state:number
}
export class State {
    id:number
    name:string
    country:number
}
export class Country {
    id:number
    name:string
    slug:string
}

export class CountryResponseModel {
    count:number
    next:string
    previous:string
    results: Country[]
    initialValue?:any
}
export class StateResponseModel {
    count:number
    next:string
    previous:string
    results:  State[]
    initialValue?:any
}
export class CityResponseModel {
    count:number
    next:string
    previous:string
    results: City[]
    initialValue?:any
}
export class ClientAddressType {
    id:number
    name:string
}

export class ClientAddressTypeResponseModel {
    count:number
    next:string
    previous:string
    results: Country[]
}

export class StandardModel {
    id:number
    name:string
}

export class StandardResponseModel {
    count:number
    next:string
    previous:string
    results: StandardModel[]
}

export class EventNoteResponseModel {
    count:number
    next:string
    previous:string
    results: EventNoteModel []
}

export class EventNoteModel {
    id: number
    note: string
    tags: any[]
    created_by: number
    modified_by: number
    created_at: string
    modified_at: string
    event: number
    created_by_name: string
}

export class EventDashboardStatsModel {
  stats: EventDashboardStatsItem[]
  outsourcing: EventDashboardOutsourcingItem[]
}

export class EventDashboardStatsItem {
  name: string
  value: number
  currency?: string
}

export class EventDashboardOutsourcingItem {
  name: string
  id: string
  value: number
}



export class EventMasterDashboardStatsModel {
    results: any[]
}


export class SafetyModel {
  id?: number;
  name: string;
  slug: string;
}


export class SafetyListResponse {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: SafetyModel[] = [];
}

export class FeedbackResponseModel {
  count: number;
  next: string;
  previous: string;
  results: FeedbackModel[];
}



export class FeedbackModel {
  id: number;
  feedback: string;
  rating: number;
  created_by: number;
  modified_by: number;
  created_at: string;
  modified_at: string;
  event: number;
  vendor: number;
  created_by_name: string;
}

export class feedbackVendorResponseModel {
    count: number
    next: string
    previous: string
    results: VendorModel[]
}

export class VendorModel {
    id: number
    name: string
    email: string
    website:string
    contact_person: string
    phone_number: string
    notes: string
    categories_serviced: string[]
    location: string
    address_1:string
    address_2:string
    created_by: number
    modified_by: number
    city: number
    state:number
    country:number
    city_details:any[]
    country_code:number
    // country_code_details:countryCodeDetails
    // poc_details:PocDetails[]

  }

  export class LicenseTypeResponseModel {
    count: number;
    next: string;
    previous: string;
    results: LicenseTypeModel[];
  }

  export class LicenseTypeModel {
    id: number;
    name: string;
    slug: string;
  }
